// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1r6Uo","error":"Textarea_error__32WlY","readonly":"Textarea_readonly__UMZI1","disabled":"Textarea_disabled__10-MJ"};